export default "__VITE_ASSET__CJYKhNZ0__"